

<template>
	<div class="container card py-3">
		<div class="row justify-content-center mb-3">
			<div class="col-auto">
				<h3 class="m-0">Bestellreferenzen</h3>
			</div>
		</div>

		<div class="row align-items-center mb-2">
			<div class="col-12 d-flex">
				<b-btn @click="addingItem = !addingItem">+</b-btn>

				<div v-if="addingItem" class="d-inline-flex align-items-center">
					<b-input placeholder="Label"
									 class="ml-2 w-auto"
									 v-model="formLabel"></b-input>
					<b-input placeholder="Beschreibung"
									 class="ml-2 w-auto"
									 v-model="formDescription"
					></b-input>
					<b-btn @click="addItem()" class="ml-2">Add</b-btn>
				</div>
			</div>
		</div>

		<b-table
				:items="items"
				:fields="fields"
				striped
				hover
				small
				:key="items.length"
		>
			<template #cell(action)="data">
				<div style="white-space: pre-wrap;">
					<b-btn size="sm" variant="danger" class="ml-2"
								 @click="removeItem(data.item)">
						<i class="bi bi-trash3-fill"></i></b-btn>
				</div>
			</template>
		</b-table>
	</div>
</template>
<script>

export default {
	name: "ReferenceTableComponent",
	data() {
		return {
			items: [],
			formLabel: "",
			formDescription: "",
			fields: [
				{ key: 'label', label: 'Label' },
				{ key: 'description', label: 'Beschreibung' },
				{ key: 'action', label: '' }
			],
			addingItem: false,
		}
	},
	methods: {
		getAllItems(){
			this.loading = true;
			axios.get('/orderreferencetext/all')
					.then(response => {
						this.items = response.data;
						this.loading = false;
					})
					.catch(error => {
						console.error('Error fetching order reference texts:', error);
						this.loading = false;
						this.$bvToast.toast("Fehler: Konnte Bestellreferenzen nicht laden.", {
							title: "Fehler",
							noAutoHide: true,
							appendToast: false,
							variant: 'danger'
						});
					});
		},
		addItem() {
			const newItem = {
				label: this.formLabel,
				description: this.formDescription
			};
			axios.post('/orderreferencetext', newItem)
					.then(response => {
						this.items.push(response.data);
						this.formLabel = "";
						this.formDescription = "";
						this.addingItem = false;
					})
					.catch(error => {
						console.error('Error adding order reference text:', error);
						this.$bvToast.toast("Fehler: Konnte Bestellreferenz nicht hinzufügen.", {
							title: "Fehler",
							noAutoHide: true,
							appendToast: false,
							variant: 'danger'
						});
					});
		},
		removeItem(item){
			console.log('Attempting to remove order reference text with id:', item.id);
			axios.delete('/orderreferencetext/' + item.id)
					.then(() => {
						console.log('Order reference text removed successfully');
						this.items =
								this.items.filter(i => i.id !== item.id);
					})
					.catch(error => {
						console.error('Error removing order reference text:', error);
						this.$bvToast.toast("Fehler: Konnte Bestellreferenz nicht entfernen.", {
							title: "Fehler",
							noAutoHide: true,
							appendToast: false,
							variant: 'danger'
						});
					})
		}
	},
	created() {
		this.getAllItems();
	}

}
</script>
